<p-dialog
  header="Modifica scheda"
  [(visible)]="visible"
  [style]="{width: '80%', height: '99%'}"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [closable]="true"
  styleClass="p-dialog-modifica-scheda"
>
<ng-template pTemplate="header">
  <div class="dialog-header" style="padding: 0.5rem; display: flex; align-items: center; justify-content: space-between;">
    <div style="display: flex; align-items: center;">
      <h2 style="font-size: 1.2rem; margin: 0;">Modifica la scheda</h2>
      <div class="code-badge" style="background-color: #f5f5f5; padding: 0.25rem 0.5rem; border-radius: 4px; margin-left: 1rem;">
        <span class="code-value" style="font-weight: bold; color: #3a6e75;">{{ scheda?.codice }}</span>
      </div>
      <button
        pButton
        type="button"
        icon="pi pi-times"
        class="p-button-rounded p-button-text close-button"
        style="background-color: #f5f5f5; border-color: #f5f5f5;"
        (click)="hide()"
        [disabled]="submitting"
        pTooltip="Chiudi"
        tooltipPosition="left">
      </button>
    </div>
  </div>
</ng-template>

  <form [formGroup]="schedaForm">
    <div class="p-fluid">
      <!-- Bacino, Comune e Rio/Località -->
      <div class="p-d-flex" style="display: flex; gap: 1rem; margin-bottom: 1.5rem; margin-top: 1rem;">
        <div class="field" style="flex: 0.7;">
          <label for="bacino">Bacino <span class="required-asterisk">*</span></label>
          <p-dropdown
            id="bacino"
            formControlName="bacino"
            [options]="bacini"
            optionLabel="denominazione"
            placeholder="Seleziona bacino"
            [showClear]="true"
            styleClass="w-full"
            [appendTo]="'body'"
            [panelStyle]="{width: 'auto'}"
          >
            <ng-template let-bacino pTemplate="item">
              <div class="bacino-badge" style="margin: 0">
                <span class="code-value">{{ bacino.denominazione }}</span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>

        <div class="field" style="flex: 1;">
          <label for="comune">Comune <span class="required-asterisk">*</span></label>
          <p-dropdown
            id="comune"
            formControlName="comune"
            [options]="comuni"
            optionLabel="denominazione"
            placeholder="Seleziona comune"
            [showClear]="true"
            styleClass="w-full"
            [appendTo]="'body'"
            [panelStyle]="{width: 'auto'}"
          >
            <ng-template let-comune pTemplate="item">
              <div class="comune-badge" style="margin: 0">
                <span class="code-value">{{ comune.denominazione }}</span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
        <div class="field" style="flex: 1;">
          <label for="rioLocalita">Rio/Località</label>
          <input pInputText id="rioLocalita" formControlName="rioLocalita" placeholder="Inserisci rio o località" />
        </div>
      </div>

      <div class="p-d-flex" style="display: flex; gap: 1rem; margin-bottom: 1.5rem;">
        <div class="field" style="flex: 0.4;">
          <label for="oggetto">Oggetto dell'intervento <span class="required-asterisk">*</span></label>
          <p-dropdown
            id="oggetto"
            formControlName="oggettoIntervento"
            [options]="oggettiIntervento"
            optionLabel="descrizione"
            placeholder="Seleziona oggetto di intervento"
            [showClear]="true"
            [appendTo]="'body'"

          >
            <ng-template pTemplate="selectedItem" let-item>
              <div class="selected-object-item">
                <span class="object-badge"
                      [ngStyle]="{'background-color': stiliService.getColoreOggettoIntervento(item), 'color': '#000000'}">
                  {{ item.codice }}
                </span>
                 <span style="font-size: 10px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 300px; display: inline-block;">{{ item.descrizione }}</span>

              </div>
            </ng-template>
            <ng-template pTemplate="item" let-item>
              <div class="dropdown-item" >
                <span class="object-badge"
                      [ngStyle]="{'background-color': stiliService.getColoreOggettoIntervento(item), 'color': '#000000'}">
                  {{ item.codice }}
                </span>
                <span style="font-size: 10px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 300px; display: inline-block;">{{ item.descrizione }}</span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
        <div class="field" style="flex: 0.3;">
          <label for="codiceAto">Codice Tipologia Intervento<span class="required-asterisk">*</span></label>
          <p-dropdown
            id="codiceAto"
            formControlName="nuovoCodiceAto"
            [options]="codiciAtoFiltrati"
            optionLabel="descrizione"
            placeholder="Seleziona codice Tipologia Intervento"
            [showClear]="true"
            [appendTo]="'body'"
          >
            <ng-template pTemplate="selectedItem" let-item>
              <div class="selected-object-item">
                <span class="object-badge"
                      [ngStyle]="{'background-color': stiliService.getColoreCodiceAto(item.codice), 'color': '#000000'}">
                  {{ item.codice }}
                </span>
              </div>
            </ng-template>
            <ng-template pTemplate="item" let-item>
              <div class="dropdown-item" >
                <span class="object-badge"
                      [ngStyle]="{'background-color': stiliService.getColoreCodiceAto(item.codice), 'color': '#000000'}">
                  {{ item.codice }}
                </span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
        <div class="field" style="flex: 0.3;">
          <label for="CodiceAto">Vecchio codice ATO</label>
          <p-dropdown
            id="codiceAtoVecchio"
            formControlName="codiceAto"
            [options]="codiciAtoDb"
            optionLabel="codice"
            dataKey="id"
            placeholder="Seleziona vecchio codice ATO"
            [showClear]="true"
            [appendTo]="'body'"
            [filter]="true"
            filterBy="codice"
            emptyMessage="Nessun codice ATO disponibile"
            emptyFilterMessage="Nessun risultato"
          >
            <ng-template pTemplate="selectedItem" let-item>
              <span [ngStyle]="{
                'background-color': stiliService.getColoreCodiceAto(item.codice),
                'color': '#000000',
                'padding': '4px 8px',
                'border-radius': '4px',
                'font-weight': 'bold',
                'font-size': '11.5px',
                'width': 'fit-content',
                'display': 'inline-block'
              }">{{ item.codice }}</span>
            </ng-template>
            <ng-template pTemplate="item" let-item>
              <span [ngStyle]="{
                'background-color': stiliService.getColoreCodiceAto(item.codice),
                'color': '#000000',
                'padding': '4px 8px',
                'border-radius': '4px',
                'font-weight': 'bold',
                'font-size': '11.5px',
                'width': 'fit-content',
                'display': 'inline-block'
              }">{{ item.codice }}</span>
            </ng-template>
          </p-dropdown>
        </div>
        <div class="field" style="flex: 0.1;">
          <label for="frequenza">Frequenza</label>
          <p-inputNumber
            id="frequenza"
            formControlName="frequenza"
            [min]="1"
            [max]="12"
            spinnerMode="horizontal"
            placeholder="1"
            styleClass="w-full"
            [style]="{'height': '50px'}"
          ></p-inputNumber>
        </div>
        <div class="field" style="flex: 0.2;">
          <label for="accessibilita">Accessibilità</label>
          <p-dropdown
            id="accessibilita"
            formControlName="accessibilita"
            [options]="accessibilita"
            optionLabel="descrizione"
            placeholder="Seleziona accessibilità"
            [showClear]="true"
            styleClass="w-full"
            [appendTo]="'body'"
            [panelStyle]="{width: 'auto'}"
          >
            <ng-template pTemplate="selectedItem" let-item>
              <div class="selected-item">
                <span class="accessibilita-icon" [ngStyle]="stiliService.getStileAccessibilitaCompatto(item.id)">
                  <span *ngIf="item.id !== 2 && item.id !== 3" class="material-icons" [ngStyle]="stiliService.getStileIconaAccessibilita(item.id)">
                    {{ stiliService.getIconaAccessibilita(item.id) }}
                  </span>
                  <img *ngIf="item.id === 2" [ngStyle]="stiliService.getStileAccessibilitaSpeciale(item.id)" src="assets/icons/car-suv.svg" alt="car-suv">
                  <img *ngIf="item.id === 3" [ngStyle]="stiliService.getStileAccessibilitaSpeciale(item.id)" src="assets/icons/car-crane.svg" alt="car-crane">
                </span>
              </div>
            </ng-template>
            <ng-template pTemplate="item" let-item>
              <div class="dropdown-item">
                <span class="accessibilita-icon" [ngStyle]="stiliService.getStileAccessibilitaCompatto(item.id)">
                  <span *ngIf="item.id !== 2 && item.id !== 3" class="material-icons" [ngStyle]="stiliService.getStileIconaAccessibilita(item.id)">
                    {{ stiliService.getIconaAccessibilita(item.id) }}
                  </span>
                  <img *ngIf="item.id === 2" [ngStyle]="stiliService.getStileAccessibilitaSpeciale(item.id)" src="assets/icons/car-suv.svg" alt="car-suv">
                  <img *ngIf="item.id === 3" [ngStyle]="stiliService.getStileAccessibilitaSpeciale(item.id)" src="assets/icons/car-crane.svg" alt="car-crane">
                </span>
                <span style="font-size: 10px;">{{ item.descrizione }}</span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
      </div>


      <!-- Anni interventi e importo -->
      <div class="p-d-flex" style="display: flex; gap: 1rem; margin-bottom: 0.5rem;">
        <div class="field" style="flex: 1;">
          <label for="annoUltimoIntervento">Anno ultimo intervento</label>
          <p-calendar
            id="annoUltimoIntervento"
            formControlName="annoUltimoIntervento"
            view="year"
            dateFormat="yy"
            [yearNavigator]="true"
            [yearRange]="'2015:2100'"
            placeholder="Anno"
            [showIcon]="true"
            [appendTo]="'body'"
          ></p-calendar>
        </div>
        <div class="field" style="flex: 1;">
          <label for="annoProssimoIntervento">Anno prossimo intervento</label>
          <p-calendar
            id="annoProssimoIntervento"
            formControlName="annoProssimoIntervento"
            view="year"
            dateFormat="yy"
            [yearNavigator]="true"
            [yearRange]="'2015:2100'"
            placeholder="Anno"
            [showIcon]="true"
            [appendTo]="'body'"
          ></p-calendar>
        </div>
        <div class="field" style="flex: 1;">
          <label for="importoUltimoIntervento">Importo ultimo intervento (€)</label>
          <p-inputNumber
            id="importoUltimoIntervento"
            formControlName="importoUltimoIntervento"
            [min]="0"
            [max]="9999999"
            [showButtons]="true"
            buttonLayout="horizontal"
            spinnerMode="horizontal"
            decrementButtonClass="p-button-secondary"
            incrementButtonClass="p-button-secondary"
            incrementButtonIcon="pi pi-plus"
            decrementButtonIcon="pi pi-minus"
            placeholder="Importo"
            mode="currency"
            currency="EUR"
            locale="it-IT"
          ></p-inputNumber>
        </div>
      </div>
      <div class="form-group full-width" style="margin-top: 0.7rem;">
        <label for="note">Note</label>
        <textarea pInputTextarea id="note" formControlName="note" rows="2" placeholder="Inserisci eventuali note" style="resize: vertical"></textarea>
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="dialog-actions" style="display: flex; justify-content: flex-end; gap: 0.5rem;">
      <button
        pButton
        type="button"
        label="Annulla"
        class="p-button-outlined p-button-secondary"
        (click)="hide()"
        [disabled]="submitting"
      ></button>
      <button
        pButton
        type="button"
        label="Salva modifiche"
        class="p-button" style="background-color: #245358; border-color: #245358;"
        (click)="salvaModifiche()"
        [loading]="submitting"
        [disabled]="schedaForm.invalid || submitting"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<p-toast position="top-right"></p-toast>
